import { Appointment } from ".";

export enum AppointmentType
{
    Other = 0,
    Service = 1,
    TyreMaintenance = 2,
    TyreRepair = 3,
    TyreReplacement = 4,
    BatteryReplacement = 5,
    WindscreenRepair = 6,
    RecallRepair = 7,
};

export namespace AppointmentType
{
    export function toString( stateOrAppointment: AppointmentType | Appointment )
    {

        const type = stateOrAppointment instanceof Appointment ? stateOrAppointment.appointmentType : stateOrAppointment;

        switch( type )
        {
            case AppointmentType.Service: return 'Service';
            case AppointmentType.TyreMaintenance: return 'Tyre maintenance';
            case AppointmentType.TyreRepair: return 'Tyre repair';
            case AppointmentType.TyreReplacement: return 'Tyre replacement';
            case AppointmentType.BatteryReplacement: return 'Battery replacement';
            case AppointmentType.WindscreenRepair: return 'Windscreen repair';
            case AppointmentType.RecallRepair: return 'Recall repair';
            default: return 'Other';
        }
    
    }
}
